import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
import AddOns from '../components/defaultProduct';
import Customiser from '../components/customiser';
docReady(() => {
    console.log('Cardigang: Product JS Loaded');
    AddOns.init();
    Customiser.init();
});
